import VueSelect from 'vue-select'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('VueSelect', VueSelect)
})
